import { AutocompleteProps, Autocomplete as DefaultAutocomplete, Popper, PopperProps, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { UseFormRegisterReturn } from 'react-hook-form';

import Input from './Input';

type CustomAutocompleteProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
> = Omit<AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>, 'renderInput'> & {
  label: string;
  validationRegister?: UseFormRegisterReturn;
  error?: boolean;
  helperText?: string;
};

const useStyles = makeStyles(({ palette }: Theme) => ({
  customPopper: {
    '& ::-webkit-scrollbar': {
      height: '8px',
      width: '6px',
    },
    '& ::-webkit-scrollbar-track-piece': {
      background: palette.neutral[300],
    },
    '& ::-webkit-scrollbar-thumb:vertical, & ::-webkit-scrollbar-thumb:horizontal': {
      background: palette.neutral[400],
      borderRadius: '20px',
    },
  },
}));

const CustomPopper = ({ className, ...props }: PopperProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Popper
      {...props}
      open
      className={`${className} ${styles.customPopper}`}
    />
  );
};

export const Autocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({
  validationRegister,
  label,
  error,
  helperText,
  placeholder,
  noOptionsText,
  ...props
}: CustomAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): JSX.Element => (
  <DefaultAutocomplete
    {...props}
    renderInput={(params) => (
      <Input {...params} error={error} label={label} placeholder={placeholder} helperText={helperText}  />
    )}
    {...validationRegister}
  />
);

export default Autocomplete;
